<template>
  <validation-observer ref="dataForm">
    <b-row>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.intake')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="intake"
            vid="intake"
            rules="required"
            :custom-messages="{ required: 'موسم التسجيل مطلوب' }"
          >
            <b-form-select
              v-model="newItem.intake"
              :placeholder="$t('addwizard.intake')"
            >
              <option value="" disabled>اختيار</option>
              <option v-for="(year,index) in years" :value="year.value">{{year.key}} </option>            </b-form-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.work_load')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="duration"
            vid="duration"
            rules="required"
            :custom-messages="{ required: ' المدة مطلوبة' }"

          >
            <div class="demo-inline-spacing">
              <b-form-radio
                v-model="newItem.Workload"
                name="some-radios"
                value="F"
                @input="SetOptions()"
              >
                {{ $t("addwizard.full_time") }}
              </b-form-radio>
              <b-form-radio
                v-model="newItem.Workload"
                name="some-radios"
                value="P"
                @input="SetOptions()"
              >
                {{ $t("addwizard.part_time") }}
              </b-form-radio>
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.first_choice')"
          label-for="input-27"
          label-cols-md="3"

        >
          <validation-provider
            #default="{ errors }"
            name="firstChoice"
            vid="firstChoice"
            rules="required"
            :custom-messages="{ required: ' الاختيار الأول مطلوب' }"
          >
            <b-form-select
              v-model="newItem.first_choice"
              :placeholder="$t('addwizard.first_choice')"
              :options="options"
              value-field="Value"
              text-field="Text"
              name="firstChoice"
              @input="Setlanguage('languageFirstOptions', newItem.first_choice)"
            >
            </b-form-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12" v-if="languageFirstOptions.length > 0">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.language_of_study')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="duration"
            vid="duration"
            rules="required"
            :custom-messages="{ required: ' اللغة مطلوبة' }"
          >
            <b-form-select
              v-model="newItem.FirstCourseLanguageOfStudy"
              :placeholder="$t('addwizard.language_of_study')"
              :options="languageFirstOptions"
            >
            </b-form-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col md="12">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.second_choice')"
          label-for="input-27"
          label-cols-md="3"
          ><validation-provider
            #default="{ errors }"
            name="second_choice"
            vid="secondChoice"
            rules="required"
            ref="secondChoice"
            :custom-messages="{ required: ' الاختيار الثاني مطلوب' }"
          >
            <b-form-select
              v-model="newItem.second_choice"
              :placeholder="$t('addwizard.second_choice')"
              :options="options.filter((a) => a.Value != newItem.first_choice)"
              value-field="Value"
              text-field="Text"
              @input="
                Setlanguage('languageSecondOptions', newItem.second_choice)
              "
            >
            </b-form-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12" v-if="languageSecondOptions.lenght > 0">
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.language_of_study')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="duration"
            vid="duration"
            rules="required"
            :custom-messages="{ required: ' اللغة مطلوبة' }"
          >
            <b-form-select
              v-model="newItem.SecondCourseLanguageOfStudy"
              :placeholder="$t('addwizard.language_of_study')"
              :options="languageSecondOptions"
            >
            </b-form-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations"; 
import MediuEduController from '@/Controllers/MediuEduController';
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      newItem: {},
      coursesOptions: [],
      options: [],
      languageFirstOptions: [],
      languageSecondOptions: [],
      years: [],
    };
  },

  async created() {
   const ct = new MediuEduController();
    // GetCourse

     let coursesOptions = await  ct.GetCourse();
    console.log(coursesOptions);

    let years = await ct.GetYears();

    this.years = years;
    this.coursesOptions = coursesOptions.map((a) => {
      return {
        Value: a.CourseCode,
        Text: a.NameAr,
        Workload: a.Workload,
        LanguageOfStudy: a.LanguageOfStudy,
      };
    });
  },
  methods: {
    SetOptions() {
      this.options = this.coursesOptions.filter(
        (a) => a.Workload == this.newItem.Workload
      );
    },
    Setlanguage(options, CourseCode) {
      this[options] = [];
      let course = this.coursesOptions.find((a) => a.Value == CourseCode);
      console.log(course);
      if (course.LanguageOfStudy.includes("/")) {
        this[options] = course.LanguageOfStudy.split("/");
      }
    },
    async returnData() {
      if (this.newItem.first_choice == this.newItem.second_choice) {
        this.$refs.dataForm.setErrors(
          "الاختيار الثاني، يجب أن لا يكون نفسه الاختيار الأول"
        );
      }

      const isValid = await this.$refs.dataForm.validate();
      if (!isValid) {
        return { valid: false };
      }
      return { valid: true, data: this.newItem };
    },
  },
};
</script>

 